import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import {
  saveConditionDeviceStateInfo,
  saveConditionStateDescription,
} from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectColorConditionState
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateCondition/ColorCondition/SelectColorConditionState'
import SelectColorConditionStateIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateCondition/ColorCondition/SelectColorConditionState'
import {
  withAccessDenied, withNotifications, withProgressAndErrorMessage, withRouter,
} from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectColorConditionStateIOS) : withStyles(SelectColorConditionState)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const { isEditConditionMode } = state.scenes.currentSceneCreating
  const { conditionDeviceNumber } = state.scenes.currentSceneCreating.currentCondition
  return {
    isMobile,
    path,
    isEditConditionMode,
    conditionDeviceNumber,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
    inProgress: state.apiRequest.inProgress,
    errorMessage: state.apiRequest.errorMessage,
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveConditionDeviceStateInfo,
  saveConditionStateDescription,
}, dispatch)

enhance = withProgressAndErrorMessage(enhance)
enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectColorConditionStateEnhanced = enhance

export default withRouter(SelectColorConditionStateEnhanced)
